import { useQuery } from '@tanstack/react-query';

import { getCurrentUser } from '@/api/auth/get-current-user';

import { authKeys } from './query-keys';

export const useCurrentUser = () =>
  useQuery({
    queryKey: authKeys.currentUser(),
    queryFn: getCurrentUser,
    staleTime: 5 * 60 * 1000,
    // A role changed in another tab, or dropped by a refresh, must show up
    // when the person comes back here, not five minutes later.
    refetchOnWindowFocus: 'always',
    retry: false,
  });
